import { TaskDefinition } from '../Types';
import scenario1 from './scenario1.json'
import scenario2 from './scenario2.json'
import scenario3 from './scenario3.json'
import scenario4 from './scenario4.json'

// JSON files should be the same as in the Unity project

export interface Scenario {
	index: number;
	sceneCount: number;
	tasks: TaskDefinition[];
}

const scenarios: any[] = [
	scenario1,
	scenario2,
	scenario3,
	scenario4
];

const taskTypes: string[] = [
	"soloTask",
	"roleTask",
	"roleSplitTask"
]

export const scenarioTitles: string[] = scenarios.map((s, index) => `${index + 1}: ${s.title}`);

export function GetScenario(index: number): Scenario {
	let scenJSON;

	switch(index) {
		case 0:
			scenJSON = scenario1;
			break;
		case 1:
			scenJSON = scenario2;
			break;
		case 2:
			scenJSON = scenario3;
			break;
		case 3:
			scenJSON = scenario4;
			break;
		default:
			scenJSON = scenario1;
			break;
	}

	let returnScenario: Scenario = {
		index: index,
		sceneCount: scenJSON.scenes.length,
		tasks: []
	};

	scenJSON.scenes.forEach(scene => {
		if (taskTypes.includes(scene.type)) {
			scene.views.forEach((view: any) => {
				returnScenario.tasks.push({
					id: `${view.title.replaceAll(" ", "_").toLowerCase()}_${view.taskIndex}`,
					taskIndex: view.taskIndex,
					stageIndex: view.stageIndex,
					name: `${view.stageIndex + 1}-${view.taskNumber}: ${view.taskName}`,
					question: view.activity.question,
					answers: view.activity.answers,
					correctAnswersGroups: view.activity.correctAnswersGroups,
					isSolo: scene.type === "soloTask" ? true : false,
					roleIndexes: view.roleIndexes,
				})
			})
		}
	});

	return returnScenario;
}